import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  filter: {
    cameraIds?: Array<number>
    clientIds?: Array<number>
    companyIds?: Array<number>
    status?: Array<string>
  }
  start: string
  end: string
}

export default function useDashboardEventsByStatus({filter, start, end}: Props) {
  const query = useQuery({
    refetchOnWindowFocus: false,
    queryKey: [QueryKeyEnum.DASHBOARD_EVENTS_BY_STATUS, filter, start, end],
    queryFn: async () => (await api.reports.getSeriesByStatus({filter, start, end})).data.data,
  })

  return query
}
